import {Injectable} from 'ng-metadata/core';
import {AbstractRequest} from './abstractRequest';
import {FormBuilderEnums} from '../../../../../../infra/formBuilder/formBuilder.service';
import { MappingTablesCache } from '../../../../../../mappingTablesCache/mappingTablesCache.service';
import { ConfigurationUtil } from '../../../../../../nddUtils/configurationUtil.service';

@Injectable()
export class AcquisitionRequest extends AbstractRequest {


	constructor(
		private mappingTablesCache : MappingTablesCache,
        private configurationUtil:ConfigurationUtil
	) {
        super();
		this.formFields = [
			{
				key: 'request_issue',
				name: 'request_issue',
				label: 'ill.request_issue',
				value: '',
				fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
				uiType: FormBuilderEnums.UI_TYPE.TEXT
			}
		];
	}
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestTypes/acquisitionRequest.ts